import styles from './termsOfUse.module.scss';

export default function TermsOfUseTemplate() {
    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <h2 className={styles.heading} style={{ alignSelf: 'center' }}>
                    Service Provider Terms of Use (Pilot)
                </h2>
            </div>
            <p className={styles.paragraph}>
                These Terms of Use (<b>“Terms”</b>) shall apply to the online custom immigration
                service provider’s (“you” and/or “your” and/or <b>“Provider”</b>) use of Aliro
                [Aliro Technologies INC ]’s (<b>“Aliro”</b>) proprietary custom immigration services
                platform (“Platform”) either identified in one or more registration documents (which
                documents maybe be in electronic or digital format) signed and/or accepted digitally
                by the Aliro and yourself parties (each an “Registration Form”) or, if there is no
                Registration Form executed by you than upon your access and/or use of the Platform.
                Your execution of a Registration Form referencing these Terms and/or access or use
                of the Platform shall be deemed your agreement to these Terms. These Terms and all
                Registration Forms (collectively referred to as the “Agreement”) represent your and
                Aliro (“Parties”) entire understanding regarding the Platform and shall govern over
                any different or additional terms of any Registration Forms and no terms included in
                any such Registration Forms shall apply to the Platform unless such different terms
                are stated specifically in a mutually signed Registration Form.
            </p>
            <p className={styles.paragraph}>
                Upon the earlier of you: (a) signing and submitting a Registration Form; or (b)
                checking “I agree”, where applicable while accessing and/or using the Platform via
                Aliro’s web site located at (“Site”):&nbsp;
                <a
                    href="http://aliroimmigration.com/"
                    style={{ color: 'blue', textDecoration: 'underline' }}
                >
                    http://aliroimmigration.com/
                </a>
                , you shall be deemed to have confirmed and agreed that: (i) you have read the
                Agreement, understood them, and that such confirmation and agreement constitutes a
                valid and legally binding contract between you and Aliro; and (ii) you are fully and
                duly certified and licensed to provide the immigration services in the applicable
                jurisdiction(s) detailed in your Registration Form. If you confirmed and agreed to
                the Agreement terms, on behalf of a corporation or another legal entity, you shall
                have been deemed to have represented and warranted that you have the authority to
                bind such entity to the terms and conditions contained within such Agreement.
            </p>
            <p className={styles.paragraph}>
                Aliro may update or modify the Agreement terms and/or the Platform from time to time
                as further detailed herein. If, in Aliro’s reasonable judgment, any such
                modification to the Platform materially reduces the functionality of the Platform,
                Aliro will endeavor to inform you via the e-mail address associated with your
                Provider Account (as defined below), no less than 5 days prior to such change. Your
                continued access and/or use of the Platform following such changes or modifications
                shall be deemed to be acceptance of such revised Platform and/or Agreement terms.
            </p>
            <ol className={styles.list}>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>The Platform</h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            Subject to your compliance with the Agreement terms, you will be granted
                            with the right to access and use the Platform which includes an online
                            marketplace that shall enable you to advertise your immigration services
                            and related products (“Provider Services”) to potential clients
                            (“Client(s)”), and to interact and engage via the Platform with such
                            Clients that are seeking to receive such applicable Provider
                            Services.{' '}
                        </li>
                        <li className={styles.listItem}>
                            Subject to these Terms and during your Subscription Pilot Term (as
                            defined below), you will also receive access to the features set forth
                            in your Registration Form which may enable you to, inter alia: (a)
                            advertise/ offer your immigration services and related products on the
                            Platform (“Listings”); (b) get more qualified Client leads; (c) manage
                            Clients application process; and (d) receive additional services from
                            Aliro and its affiliates, as may be offered by Aliro from time to
                            time.{' '}
                        </li>
                        <li className={styles.listItem}>
                            While filing out and executing your Registration Form to make a Listings
                            via the Platform you undertake and represent that you shall provide
                            complete, accurate, and updated information about your Provider Services
                            and your license and certification status in the jurisdiction(s) set
                            forth in your Registration Form. In addition to the above, you agree to
                            provide any other related information reasonably requested by Aliro; and
                            hereby undertake to notify Aliro immediately in writing (via the contact
                            details set forth in section 13.11 below), of any change in your license
                            and certification status.
                        </li>
                        <li className={styles.listItem}>
                            The position, prominence and placement of your services and products on
                            the Platform pursuant to Aliro’s standard parameters. You authorize
                            Aliro to use and display your marketing materials and to market and
                            promote your services and products and their availability on the
                            Platform, but you recognize that Aliro has no obligation to market or
                            promote your service and products other than as set forth in the
                            Registration Form.
                        </li>
                        <li className={styles.listItem}>
                            You acknowledge and confirm that you are aware that: (a) Aliro, as the
                            provider of the Platform does and will not offer, sell, engage, control,
                            manage, supervise, deliver, or provide any Provider Services on your
                            behalf; (b) under each engagement between a Client and yourself for any
                            service or product including for Provider Services published via the
                            Platform, you shall be solely responsible and liable towards such Client
                            for the offer, sale, engagement, control, management, supervision, and
                            delivery and etc. of any service or product including for Provider
                            Services published via the Platform or any other engagement with a
                            Client; and (c) Aliro shall not be deemed as a party to any of the said
                            engagements between you and the Clients and/or anyone else on such
                            parties behalf.
                        </li>
                    </ol>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>Account Information</h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            In the Registration Form to access and use the Platform, you will be
                            required to create a Provider account (“Provider Account”). When
                            registering to create a Provider Account, you are required to select a
                            password and provide certain information as specified in the
                            Registration Form (“Login Information”).
                        </li>
                        <li className={styles.listItem}>
                            As part of the registration process, you agree to provide Aliro with:
                            (a) accurate and complete information pursuant to Aliro’s request and
                            (b) all on engagement agreements /onboarding documents that will be used
                            between yourself and Clients engaged via the Platform (“Provider
                            Engagement Agreements”). You further agree to update Aliro (in the same
                            manner set forth in section 1.3) of any change in the information
                            requested pursuant to sub-section (a) promptly after it changes, and not
                            to amend any of the Provider Engagement Agreements without the written
                            approval of Aliro. Additionally, you represent and warrant that you have
                            full right and authority to provide Aliro with the foregoing
                            information, including, without limitation, any third party's consent
                            (to the extent required under any applicable law or contract).{' '}
                        </li>
                        <li className={styles.listItem}>
                            You hereby permit Aliro to review and monitor (a) commercial
                            transactions and engagements you make with Clients, and (b) in case of a
                            dispute with a Client, the applicable correspondence and Client Data (as
                            defined below), for the sole purpose of ensuring your compliance with
                            these Terms and the terms and conditions set forth in your Provider
                            Engagement Agreements. Aliro shall only utilize such specific and
                            limited information received from or related to your Provider Account
                            for the above-mentioned purposes.
                        </li>
                        <li className={styles.listItem}>
                            Any Login Information you shall provide Aliro when creating or updating
                            the Provider Account will be held and used in accordance with Aliro’s
                            Privacy Policy available at: [link] (“Privacy Policy”), as may be
                            amended from time to time which also constitutes an integral part of
                            these Terms.{' '}
                        </li>
                        <li className={styles.listItem}>
                            The following rules govern the security of your Provider Account and
                            Login Information. For the purposes of these Terms, references to a
                            Provider Account and Login Information shall include any account and
                            account information, including usernames, passwords or security
                            questions, whether or not created for the purpose of using the Platform,
                            that are used to access the Platform:
                            <ol className={styles.list}>
                                <li className={styles.listItem}>
                                    You shall not share your Provider Account or Login Information,
                                    nor let anyone else access your Provider Account or do anything
                                    else that might jeopardize the security of your Provider
                                    Account;
                                </li>
                                <li className={styles.listItem}>
                                    In the event you become aware of or reasonably suspect any
                                    breach of security, including, without limitation any loss,
                                    theft, or unauthorized disclosure of your Login Information or
                                    unauthorized access to your Provider Account, you must
                                    immediately notify Aliro and modify your Login Information;
                                </li>
                                <li className={styles.listItem}>
                                    You are solely responsible for maintaining the confidentiality
                                    of the Login Information, and will be responsible for all uses
                                    of the Login Information, including purchases, whether or not
                                    authorized by yourself;
                                </li>
                                <li className={styles.listItem}>
                                    You are responsible for anything that happens through your
                                    Provider Account, whether or not such actions were taken by you,
                                    including, for the avoidance of doubt, actions taken by third
                                    parties or any one on your behalf. You therefore acknowledge
                                    that your Provider Account may be terminated if someone else
                                    uses it to engage in any activity that violates the Agreement or
                                    is otherwise improper or illegal;
                                </li>
                                <li className={styles.listItem}>
                                    You undertake to monitor your Provider Account and restrict use
                                    by any individual barred from accepting the Agreement terms
                                    and/or receiving access to or use of the Platform, under the
                                    provisions listed herein or any applicable law. You accept full
                                    responsibility for any unauthorized use of the Platform by any
                                    of the above mentioned;
                                </li>
                                <li className={styles.listItem}>
                                    Aliro reserves the right to remove or reclaim any usernames at
                                    any time and for any reason, including but not limited to claims
                                    by a third party that a username violates such third party's
                                    rights.
                                </li>
                            </ol>
                        </li>
                    </ol>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>Rules of Conduct and Usage</h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            You agree to comply fully with these Terms, your Provider Engagement
                            Agreements and all applicable domestic and international laws,
                            regulations, statutes, ordinances that govern your use of the Platform.
                            Without limiting the foregoing and in recognition of the global nature
                            of the Internet, you agree to comply with all local and international
                            rules regarding online conduct. You also agree to comply with all
                            applicable laws affecting the transmission of content or the privacy of
                            the Clients or any other individuals.
                        </li>
                        <li className={styles.listItem}>
                            You hereby agree that in case that Aliro determines that you have acted
                            in violation of the Agreement terms or any applicable law while using
                            the Platform, or if Aliro determines your actions fall outside of
                            reasonable standards, Aliro may, at its sole discretion, terminate your
                            Provider Account and prohibit you from accessing or using the Platform.
                            In furtherance of the foregoing, and as an example and not as a
                            limitation, you hereby agree that by using the Platform you shall not
                            act as follows:
                            <ol className={styles.list}>
                                <li className={styles.listItem}>
                                    Grant access, rent, lease, sell, transfer, assign and/or
                                    sublicense your Provider Account to any person or entity, or
                                    access a Provider Account which has been rented, leased, sold,
                                    transferred, assigned and/or sublicensed.
                                </li>
                                <li className={styles.listItem}>
                                    Upload or transmit (or attempt to upload or transmit) files that
                                    contain viruses, trojan horses, worms, time bombs, cancelbots,
                                    corrupted files or data, or any other similar software or
                                    programs that may damage the operation of the Platform.
                                </li>
                                <li className={styles.listItem}>
                                    Violate the contractual, personal, privacy, intellectual
                                    property or other rights of any party including by using,
                                    uploading, transmitting, distributing, or otherwise making
                                    available any information or material made available through the
                                    Platform in any manner that infringes any copyright, trademark,
                                    design, patent, trade secret, or other rights of any party
                                    (including rights of privacy or publicity).
                                </li>
                                <li className={styles.listItem}>
                                    Create false personas, multiple identities, multiple user
                                    Provider Accounts, set up a Provider Account on behalf of
                                    someone else.
                                </li>
                                <li className={styles.listItem}>
                                    Post a Listing that as a result of such posting will be deemed
                                    to be in breach of any agreements you have entered into with any
                                    third parties.
                                </li>
                                <li className={styles.listItem}>
                                    Attempt to obtain passwords or other private information from
                                    other members including personally identifiable information
                                    (whether in text, image or video form), identification
                                    documents, or financial information.
                                </li>
                                <li className={styles.listItem}>
                                    Upload or transmit (or attempt to upload or to transmit), any
                                    material that acts as a passive or active information collection
                                    or transmission mechanism, including, without limitation, clear
                                    graphics interchange formats (“gifs”), 1x1 pixels, web bugs,
                                    cookies or other similar devices (sometimes referred to as
                                    “spyware”, “passive collection mechanisms” or “pcms”). Use any
                                    robot, spider, scraper, data mining tools, data gathering and
                                    extraction tools, or other automated means to access the
                                    Platform for any purpose.
                                </li>
                                <li className={styles.listItem}>
                                    Attempt to interfere with, hack into or decipher any
                                    transmissions to or from the servers for the Platform.
                                </li>
                                <li className={styles.listItem}>
                                    Defraud, or attempt to defraud, Aliro or its users, and acting
                                    in bad faith in your use of the Platform.
                                </li>
                                <li className={styles.listItem}>
                                    Build a competitive marketplace, product or service or to
                                    otherwise copy the features, functionality or user interfaces of
                                    the Platform.
                                </li>
                                <li className={styles.listItem}>
                                    Use the Platform in any manner that diverts Client from the
                                    Platform or that directs Client to a website that is not owned
                                    or controlled by Aliro.
                                </li>
                            </ol>
                        </li>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>
                                Reviews and Ratings.
                            </span>
                            &nbsp; The Platform may include social networking functionality that
                            will allow end users to review and rate services and products. You agree
                            that this functionality is important to the success of the Platform,
                            even if it results in unfavorable reviews or ratings of your services
                            and products. In order to preserve the integrity of these reviews and
                            ratings, you agree that you will not, directly or indirectly (i) offer
                            incentives to your Clients to rate your service and products; and/or
                            (ii) take any other action that could reasonably be expected to
                            artificially increase favorable reviews or ratings of your own services
                            and products, and/or (iii) artificially increase unfavorable reviews or
                            ratings of the services and products of any of your competitors. You
                            acknowledge and agree that your Listing will be ranked and placed in the
                            Client search results on the Platform, in accordance to a calculation
                            based on a variety of factors, such as turnaround, MOQ, design
                            flexibility, “Rankings”, “Reviews”, Client’ requirements etc.
                        </li>
                    </ol>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>Pricing and Payments </h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            All fees for Provider Services and related products offered to Clients
                            shall be published by yourself on the Platform via each applicable
                            Listing (“Service Price”), and all payments of Service Prices for such
                            service and products by the Clients shall be paid solely via the Payment
                            Processor (as defined below) and shall be processed pursuant to the
                            terms set forth below. Unless approved otherwise by Aliro, the Provider
                            shall set the Service Price and the Clients shall pay the Services in US
                            Dollars (USD).
                        </li>
                        <li className={styles.listItem}>
                            During the Subscription Pilot Term, 85% of the Service Price will be
                            remitted by Aliro to the Provider via the Payment Processor; and the
                            remaining 15% percent will be retained by Aliro as consideration for the
                            use of access of the Platform by the Provider (“Aliro Fee”).
                        </li>
                        <li className={styles.listItem}>
                            The payment of the Service Price by Clients shall be made by online
                            payment services or other third-party payment processing services
                            designated by Aliro (“Payment Processor(s)”). All payments of the
                            Service Price must be made in cleared funds, meaning without any
                            deduction or set-off, even if some portion of the amount that needs to
                            be paid by a Client to yourself is required by any bank, or
                            governmental, fiscal or other authority. If a Client shall be required
                            to make any such deduction, you must pay Aliro such additional amounts
                            as are necessary to ensure Aliro’s receipt of the full Aliro Fee.
                        </li>
                        <li className={styles.listItem}>
                            You agree, and you and undertake to include applicable terms and
                            conditions agreements within your Provider Engagement Agreements, that
                            you and your Clients shall be bound by the Payment Processor(s) terms of
                            use, as they may be modified by them from time to time. As a condition
                            of Aliro enabling payment processing services through the Payment
                            Processor(s), you agree to provide Aliro accurate and complete
                            information about yourself and your business, and you authorize Aliro to
                            share transaction information related to your use of the payment
                            processing services provided by Payment Processor(s). Aliro may replace
                            its third-party payment processing services without providing you with
                            any notice.
                        </li>
                        <li className={styles.listItem}>
                            The Aliro Fees payable are non-refundable and are payable in full,
                            without any deduction of any kind including for taxes and/or duties.
                        </li>
                        <li className={styles.listItem}>
                            You shall be solely responsible for (a) collection and payment of any
                            taxes associated with receipt of rendering the Provider Services and
                            related products and using the Platform; and (b) any taxes on any
                            payments you receive from Aliro. All payments from Aliro to you are
                            inclusive of any taxes (other than withholding taxes), and where
                            applicable law requires Aliro to withhold any amounts otherwise due to
                            Provider, Aliro may withhold such amounts unless Provider provides to
                            Aliro adequate tax documentation supporting lesser withholding taxes.
                        </li>
                    </ol>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>Term and Termination</h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            The term of your account shall commence upon the execution of the
                            Registration Form and end following the lapse of a 12 month thereafter
                            (“Subscription Pilot Term”).{' '}
                        </li>
                        <li className={styles.listItem}>
                            Aliro may terminate the Agreement and your Provider Account upon 30 days
                            prior written notice, for any or no reason. You may terminate your
                            account at any time upon 30 days prior written notice.{' '}
                        </li>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>
                                Termination for Cause:
                            </span>
                            &nbsp;
                            <ol className={styles.list}>
                                <li className={styles.listItem}>
                                    If Aliro determines that you have acted in violation of the
                                    terms of the Agreement, or if Aliro determines that your actions
                                    fall outside of reasonable standards, Aliro may, at its sole
                                    discretion, terminate or suspend your Provider Account and
                                    prohibit you from using the Platform. If you have more than one
                                    Provider Account, Aliro may suspend or terminate all of your
                                    Provider Accounts.
                                </li>
                                <li className={styles.listItem}>
                                    Aliro shall have the right to immediately terminate the
                                    Agreement, upon written notice, in the event that you file a
                                    petition in bankruptcy or are adjudicated as bankrupt or
                                    insolvent, or make an assignment for the benefit of creditors,
                                    or an arrangement pursuant to any bankruptcy law, or discontinue
                                    your business or have a receiver appointed for your business.
                                </li>
                                <li className={styles.listItem}>
                                    In the event that Aliro terminates your Provider Account, you
                                    may not participate nor make use of the Platform again without
                                    Aliro's express written consent. Aliro reserves the right to
                                    refuse to keep your Provider Data (as defined below). If you
                                    believe that any action has been taken against your Provider
                                    Account in error, please contact Aliro at: &nbsp;
                                    <a
                                        href="support@aliroimmigration.com."
                                        style={{
                                            color: 'blue',
                                            textDecoration: 'underline',
                                        }}
                                    >
                                        support@aliroimmigration.com.
                                    </a>
                                </li>
                            </ol>
                        </li>
                    </ol>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>Provider Data and Client Data</h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            Aliro acknowledges that, as between you and Aliro, you own all rights,
                            title and interest in your Provider Data. Except as permitted herein,
                            Aliro acknowledges that the Agreement terms shall not convey to Aliro
                            any other rights in any of your copyrighted material.
                        </li>
                        <li className={styles.listItem}>
                            The term “Provider Data” shall mean your name, logo, trade dress,
                            trademark or service mark, the files or attachments uploaded by you to
                            the Platform (including the Provider Engagement Agreements), as well as
                            the contact information submitted to Aliro by you (if any).
                        </li>
                        <li className={styles.listItem}>
                            You represent and warrant to Aliro that you possess all rights required
                            to lawfully provide your Provider Data to Aliro and allow Aliro to use
                            such data in the performance of the Platform. Furthermore, you represent
                            and warrant that such Provider Data and/or the display of and access to
                            such materials do not infringe upon, misappropriate, or otherwise
                            violate any intellectual property, proprietary, privacy or other rights
                            of any third parties.
                        </li>
                        <li className={styles.listItem}>
                            You hereby grant to Aliro a non-exclusive, worldwide, perpetual and
                            irrevocable right to use the Provider Data for the purpose of support
                            and maintenance and for analyzing and improving the Platform.
                        </li>
                        <li className={styles.listItem}>
                            Without derogating from any of Aliro’s rights and remedies under these
                            Terms and/or under law, Aliro will be entitled to immediately
                            discontinue your access and use of the Platform in the event of any
                            alleged infringement, misappropriation or violation of any rights of any
                            third parties in connection with your Provider Data.
                        </li>
                        <li className={styles.listItem}>
                            You acknowledge and agree that Aliro has no obligation to review any of
                            the contents of the Provider Data, Client Data, including for its
                            inaccuracy or completeness, or for the potential violation of any
                            third-party rights. “Client Data” means any information a Client shall
                            upload and/or submit to the Platform.
                        </li>
                        <li className={styles.listItem}>
                            Any Provider Data and Client Data provided to Aliro as part of the
                            Platform will be held and used in accordance with Aliro's Privacy
                            Policy. In connection with providing you with access and use to the
                            Platform, Aliro may transfer, store and process Provider Data and Client
                            Data in any country in which Aliro or its affiliates maintain offices.
                            By using the Platform, you hereby consent to such transference,
                            processing and storage of the Provider Data.
                        </li>
                    </ol>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>Communication channels</h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>
                                Platform Communication Channels.
                            </span>
                            &nbsp; The Platform may now or in the future provide communication
                            channels such as blogs, forums, communities, or chat areas
                            (collectively, “Platform Communication Channels”) designed to enable you
                            to communicate with Clients and/or other Providers. Aliro is under no
                            obligation to monitor these Platform Communication Channels but may do
                            so, and reserves the right to review materials posted to the Platform
                            Communication Channels and to remove any materials, at any time, with or
                            without notice for any reason, at its sole discretion. Aliro may also
                            terminate or suspend your access to any Platform Communication Channels
                            at any time, without notice, for any of the reasons set forth in section
                            3.2 above. You acknowledge that chats, postings, or materials posted by
                            users on the Platform Communication Channels are neither endorsed nor
                            controlled by Aliro, and these communications should not be considered
                            reviewed or approved by Aliro. You will be solely responsible for your
                            activities within the Platform Communication Channels and under no
                            circumstances will Aliro be liable for any activity within the Platform
                            Communication Channels. You agree that your communications within the
                            Platform Communication Channels are public, and you have no expectation
                            of privacy regarding your use of the Platform Communication Channels.
                            Aliro is not responsible for information that you choose to share on the
                            Platform Communication Channels, or for the actions of other users.
                        </li>
                    </ol>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>Intellectual Property Ownership</h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            The Platform, including but not limited to all materials, any computer
                            software (in object code and source code form), data or information
                            employed by Aliro pursuant to these Terms, and any know-how,
                            methodologies, equipment, or processes used by Aliro to provide the
                            Platform, including without limitation all patent, copyright, trade
                            secret and any other proprietary rights therein and any other
                            deliverables provided by it hereinunder, are and shall remain the sole
                            and exclusive property of Aliro.
                        </li>
                        <li className={styles.listItem}>
                            Nothing in the Agreement gives you a right to use any of Aliro's trade
                            names, trademarks, service marks, logos, domain names, or other
                            distinctive brand features.
                        </li>
                        <li className={styles.listItem}>
                            You agrees to provide Aliro with feedback concerning the functionality
                            and performance of the Platform, from time to time, as reasonably
                            requested by Aliro, including, without limitation identifying potential
                            errors, enhancements and improvements. Any feedback, suggestions, ideas
                            or other inputs that you provide Aliro in connection with the Platform
                            may be freely used by Aliro to improve or enhance Aliro’s products and
                            services and, accordingly, all rights to such improvements and/or
                            enhancements, howsoever arising, including as a result of any ideas,
                            inputs or information provided by you as aforesaid, shall vest solely
                            with Aliro.
                        </li>
                        <li className={styles.listItem}>
                            During the course of your use of the Platform, Aliro may collect
                            information regarding your use of the Platform, such as information on
                            which tools and/or services in the Platform are being used and how they
                            are being used, connection time to Aliro's server, etc. Any such
                            information gathered by Aliro will be used in general, aggregated,
                            non‑personally identifiable form in connection with evaluating and
                            improving Aliro’s products and technology and for statistical purposes.
                            Notwithstanding, the use of any of our on-line services, shall be
                            subject to Aliro’s Privacy Policy.
                        </li>
                        <li className={styles.listItem}>
                            Your use of the Platform is limited to that specifically and explicitly
                            permitted in the Agreement. You shall not and shall not permit any third
                            party to: (a) engage in, cause, or permit the reverse engineering,
                            disassembly, decompilation or any similar manipulation or attempt to
                            discover the source code or underlying ideas or algorithms of the
                            Platform or any part thereof; (b) bypass, alter, or tamper with any
                            security or lockout features of the Platform; (c) create any derivative
                            work or translation of the Platform; or (d) provide, lease, rent, lend,
                            license, assign, delegate, or otherwise transfer or use or allow others
                            to transfer or use the Platform for the benefit of any third party.
                        </li>
                    </ol>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>Confidentiality</h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            Confidential Information (as defined below) of Aliro shall be retained
                            by you in confidence until such information becomes public through no
                            action or inaction by you, and shall be used, disclosed, and copied
                            solely for the purposes of, and in accordance with, these Terms. If
                            needed, you may disclose Confidential Information to those employees
                            solely with a need to know of such Confidential Information, and who
                            have executed an obligation of confidentiality and restriction of use
                            similar to the terms hereof. You shall use the same degree of care as
                            you use to protect your own confidential information of a similar
                            nature, but no less than reasonable care, to prevent the unauthorized
                            use, disclosure or publication of the Confidential Information.
                        </li>
                        <li className={styles.listItem}>
                            “Confidential Information” means any and all information disclosed by
                            Aliro which is: (i) not publicly available, including but not limited to
                            patent, patent application, trade secret and proprietary information,
                            techniques, sketches, drawings, models, inventions, designs, know-how,
                            processes, apparatus, equipment, computer code and algorithms, and (ii)
                            information relating to marketing plans, business opportunities,
                            personnel, research, development or know-how. Without derogating from
                            the generality of the foregoing, the Platform.
                        </li>
                        <li className={styles.listItem}>
                            It is hereby agreed that, without limiting the foregoing, all
                            intellectual property rights in and to the Platform and any and all
                            documentation, user guides, manuals, system requirements, operating
                            instructions, training, pricing rates, and terms and other data and
                            materials related to the foregoing or made available by Aliro to you
                            pursuant to these Terms and/or the Platform, are considered as
                            Confidential Information of Aliro.
                        </li>
                        <li className={styles.listItem}>
                            Aliro shall have the right to seek injunctive or other equitable relief
                            to protect its Confidential Information and intellectual property rights
                            or to prevent loss of data or damage to its servers in any court of
                            competent jurisdiction.
                        </li>
                    </ol>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>Warranty Disclaimers</h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            You acknowledge and confirm that you are aware that Aliro, as the
                            provider of the Platform, does not and will not have any responsibility
                            regarding your Provider Services, Provider Data and/or the negotiations
                            and/or engagement you may enter into with any Client.
                        </li>
                        <li className={styles.listItem}>
                            You are aware understand and agree that service and access to the
                            Platform rendered hereunder is made as part of a pilot and therefore are
                            provided on an “AS IS” and “AS AVAILABLE” basis without warranty of any
                            kind. You shall be solely responsible for any and all acts or omissions
                            taken or made in reliance on the Platform. To the fullest extent
                            permitted by law, Aliro its officers, directors, employees, and agents
                            disclaim any and all warranties, whether express or implied, including,
                            without limitation, any implied warranties of merchantability, title,
                            fitness for a particular purpose or use, satisfactory quality,
                            non-infringement, accuracy or completeness of the content of the
                            Platform or contents of any sites linked to the Platform, that any data
                            stored with Aliro will be secure or otherwise not lost or damaged, or
                            that the Platform will be uninterrupted or error free.
                        </li>
                        <li className={styles.listItem}>
                            Aliro makes no representations about the quantity, sufficiency or
                            quality of data that it provides. Aliro does not guarantee that the
                            information provided by the Platform is accurate or complete, or the
                            results to be achieved from such information, including any specific
                            conversion rates.{' '}
                        </li>
                    </ol>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>Limitations of Liability </h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            in no event shall Aliro or anyone on its behalf be liable for any
                            indirect, consequential, incidental, special or punitive damages of any
                            kind, including without limitation damages for loss of business or
                            profits, business interruption, loss of business information or loss or
                            damages to goodwill, in connection with the agreement and/or the
                            Platform regardless of the cause and whether arising in contract
                            (including fundamental breach), tort (including negligence), or
                            otherwise, even if Aliro has been advised of the possibility of such
                            damages or loss. notwithstanding anything to the contrary herein, under
                            no circumstances will Aliro’s total and aggregate liability to you from
                            all causes of action of any kind, including without limitation contract,
                            tort, negligence, strict liability, breach of warranty, or otherwise,
                            arising out of or related to the Agreement and/or the Platform, exceed
                            the fees actually paid by you to Aliro for the right to use the platform
                            in the 6 months preceding such claim.
                        </li>
                    </ol>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>Indemnification</h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            To the fullest extent permitted by applicable law, you shall defend,
                            indemnify and hold Aliro, its affiliates, and their respective officers,
                            employees Providers, service providers and/or any other person or entity
                            acting on its behalf, harmless from and against any loss, liability,
                            claim, demand, or proceedings brought against Aliro by a third party,
                            damages, costs and expenses, including reasonable attorney's fees,
                            arising out of or in connection with any of the following:
                            <ol className={styles.list}>
                                <li className={styles.listItem}>
                                    Your violation of the Agreement.
                                </li>
                                <li className={styles.listItem}>
                                    Your improper use of the Platform.{' '}
                                </li>
                                <li className={styles.listItem}>
                                    Your interaction and/or engagement with any Client, including
                                    without limitation any injuries, losses or damages (whether
                                    compensatory, direct, incidental, consequential or otherwise) of
                                    any kind arising in connection with or as a result of such
                                    interaction and/or engagement.
                                </li>
                                <li className={styles.listItem}>
                                    Your violation of any applicable laws and/or any third party
                                    right, including without limitation any copyright, property, or
                                    privacy right.
                                </li>
                            </ol>
                        </li>
                        <li className={styles.listItem}>
                            You agree not to settle and/or compromise any such claim without Aliro’s
                            prior written consent. Aliro reserves the right to assume the exclusive
                            defense and control of any matter for which you are required to
                            indemnify Aliro and you agree to cooperate with Aliro defense of such
                            claims at your expense.
                        </li>
                    </ol>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.heading}>Miscellaneous</h4>
                    <ol className={styles.list}>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>
                                Governing Law and Jurisdiction.
                            </span>
                            &nbsp; The Agreement is governed by the laws of BC, Canada, without
                            application of its principles of conflicts of law. The parties hereto
                            irrevocably consent to the exclusive jurisdiction of the competent
                            courts in [Vancouve, BC, Canada , to adjudicate all disputes arising
                            from or related to the Agreement to the exclusion of the jurisdiction of
                            any other court; however, Aliro shall retain the right to institute
                            proceedings, including interlocutory and/or injunctive relief, in any
                            other territory. The Parties hereto further agree that the United
                            Nations Convention on the International Sales Goods shall not apply to
                            the Agreement.
                        </li>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>Publicity.</span>
                            &nbsp; Aliro may identify you on the Site and other marketing materials
                            as a user of the Platform. Upon Aliro’s reasonable request, you agree to
                            provide Aliro with information regarding your use of the Platform and
                            cooperate with Aliro’s efforts to promote and market the Platform.
                        </li>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>Assignment.</span>
                            &nbsp; Neither party shall transfer, assign or pledge in any manner
                            whatsoever any of its rights or obligations under the Agreement without
                            the prior written consent of the other Party, provided however, that a
                            Party may assign its rights under the Agreement in connection with a
                            merger, acquisition, sale of all or substantially all of its assets or
                            other such corporate reorganization.
                        </li>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>Severability.</span>
                            &nbsp; If any term, provision, covenant or restriction of the Agreement
                            is held by a court of competent jurisdiction or other authority to be
                            invalid, void, unenforceable or against regulatory or public policy, the
                            remainder of the terms, provisions, covenants and restrictions of the
                            Agreement shall in no way be affected, impaired or invalidated.
                        </li>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>Amendments.</span>
                            &nbsp; The technology for the Platform is constantly evolving,
                            accordingly, Aliro reserves the right to amend the Agreement including
                            these Terms at any time in its sole discretion. Aliro will endeavor to
                            send an email with notice of any such amendments to the email address
                            you listed in your Provider Account. Any such amendments shall become
                            effective on the date that is 10 days after the date of Aliro’s email
                            notice to you. If you do not accept, or refuse to be bound by, any of
                            Aliro’s proposed amendments, you may terminate the Agreement prior to
                            the expiration of the 30-day notice period by providing written notice
                            of termination to Aliro. If you terminate the Agreement within the
                            30-day notice period, the proposed amendments will not take effect and
                            will not be binding on you. However, if you do not terminate the
                            Agreement as provided above within the 30 day notice period, then your
                            continued use of the Platform will constitute your acceptance of the
                            proposed amendments and these amendments will be binding on you. Except
                            as provided in this Section 13.6, no other act, document, usage, or
                            custom shall be deemed to amend these Terms.
                        </li>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>Entire Agreement.</span>
                            &nbsp; The terms and provisions contained the herein, and in the
                            Registration Form(s) constitute the entire agreement between the parties
                            hereto with respect to the subject matters hereof and shall supersede
                            all previous communications, oral or written, between the parties hereto
                            with respect to the subject matters hereof.
                        </li>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>Waiver.</span>
                            &nbsp; No waiver of any rights by any Party hereto shall be construed as
                            a waiver of the same or any other right at any prior or subsequent time.
                            Furthermore, no waiver or delay on the part of a Party hereto in
                            exercising any power or right hereunder, and no forbearance or
                            indulgence of a Party granted to the other Party, shall in any way
                            restrict or diminish the full rights and powers of that Party under the
                            Agreement, or operate as a waiver of any breach by a Party of any of the
                            terms or conditions of the terms of the Agreement.
                        </li>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>
                                Independent Contractor.
                            </span>
                            &nbsp; No agency, partnership, joint venture or employment relationship
                            is or shall be created by virtue of the Platform and/or the Agreement.
                        </li>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>
                                Compliance with Law.
                            </span>
                            &nbsp; You, not Aliro, are responsible for ensuring that the provision
                            of your services products comply with applicable law, including any and
                            all laws and regulations governing your provision of immigration
                            services, and applicable data privacy matters.
                        </li>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>Force Majeure.</span>
                            &nbsp; Aliro shall not be in default, or held responsible, for damages
                            caused by delay or failure to perform in full or in part its obligations
                            under these Terms, where such delay or failure is due to circumstances
                            beyond Aliro's reasonable control, including but not limited to acts of
                            God, fire, flood, war, terrorism, embargo, accident, labor disputes, or
                            shortage of material, equipment or transport, epidemic, pandemic, any
                            law, regulation, or any ruling of court, tribunal or governmental
                            agency.
                        </li>
                        <li className={styles.listItem}>
                            <span style={{ textDecoration: 'underline' }}>Notices.</span>
                            &nbsp; Any notice provided pursuant to the Agreement shall be in writing
                            and shall be sent by registered mail, or e-mail with notice of receipt
                            requested, or by hand delivery to the addresses of the parties as
                            specified herein. Notices sent to Aliro shall be addressed to
                            support@aliroimmigration.com , and to your address as set forth in the
                            Provider Account, or to the address otherwise designated from time to
                            time in writing by the Parties. All notices will be deemed to have been
                            delivered 5 business days after being mailed (return receipt requested)
                            if delivered by registered mail, or 1 business day after delivered by
                            hand or by e-mail (with confirmation of receipt).
                        </li>
                    </ol>
                </li>
            </ol>
        </div>
    );
}
